import ActionSheet from '../../action-sheet/locale/zh_CN';
import Calendar from '../../calendar/locale/zh_CN';
import CascaderView from '../../cascader-view/locale/zh_CN';
import Cascader from '../../cascader/locale/zh_CN';
import DatePickerView from '../../date-picker-view/locale/zh_CN';
import DatePicker from '../../date-picker/locale/zh_CN';
import DateSelect from '../../date-select/locale/zh_CN';
import ImagePreview from '../../image-preview/locale/zh_CN';
import Image from '../../image/locale/zh_CN';
import Keyboard from '../../keyboard/locale/zh_CN';
import Modal from '../../modal/locale/zh_CN';
import Picker from '../../picker/locale/zh_CN';
import Pull from '../../pull/locale/zh_CN';
import SearchBar from '../../search-bar/locale/zh_CN';
import Select from '../../select/locale/zh_CN';

export default {
  locale: 'zh-CN',
  ActionSheet,
  Modal,
  DatePicker,
  DatePickerView,
  DateSelect,
  Picker,
  Cascader,
  CascaderView,
  Pull,
  SearchBar,
  Select,
  Keyboard,
  ImagePreview,
  Image,
  Calendar,
};
